import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { LoisirsAtna } from '../components/loisirs/LoisirsAtna';
import { ReadinessCard } from '../components/loisirs/ReadinessCard';
import { ForYou } from '../components/loisirs/ForYou';
import { MyActivities } from '../components/loisirs/MyActivities';
import { CardAccess } from '../components/loisirs/CardAccess';
import { BookingServices } from '../components/loisirs/BookingServices';
import { RegistrationFlow } from '../components/loisirs/RegistrationFlow';
import type { Activity } from '../data/loisirs';
export function MesLoisirs() {
  const [registering, setRegistering] = useState<Activity | null>(null);
  return <main className="bg-white" data-id="element-2069" data-mp="1fzigctyyig7u">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2070" data-mp="1fy7beqtrz2f5">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2071" data-mp="2cj7l3hvdzyps">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2072" data-mp="27pwn868jysa0">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2073" data-mp="2b270zmn2vkjf" />
          <span aria-current="page" data-id="element-2074" data-mp="2fye314ccsbw3">My Recreation</span>
        </nav>

        <header className="mt-4" data-id="element-2075" data-mp="21at0pcnaygp8">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2076" data-mp="219rh2js80lvw">My Recreation</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-2077" data-mp="2671cqh67dts6">
            Find, book and get into Town programs, simply.
          </p>
        </header>

        <div className="mt-8" data-id="element-2078" data-mp="1x9h8r0gyhjdv">
          <LoisirsAtna onChip={() => undefined} data-id="element-2079" data-mp="1x9qzwrdqlwl5" />
        </div>

        <div className="mt-8" data-id="element-2080" data-mp="1ic8enz09q1ig">
          <ReadinessCard data-id="element-2081" data-mp="1iczzcesbuety" />
        </div>

        <ForYou onRegister={setRegistering} data-id="element-2082" data-mp="1na0ah441a7rx" />
        <MyActivities data-id="element-2083" data-mp="1nas1e1morhbv" />
        <CardAccess data-id="element-2084" data-mp="1nc37i83lt165" />
        <BookingServices data-id="element-2085" data-mp="3cpg4tddatoxr" />
      </div>

      <RegistrationFlow activity={registering} onClose={() => setRegistering(null)} data-id="element-2086" data-mp="3cqhq0ao13rt7" />
    </main>;
}